import { LinkContainer } from 'components/DataTable/style'
import Tooltip from 'components/Tooltip'
import { MenuTableRow } from 'pages/Menus/View/styles'
import { useState } from 'react'
import { AiOutlineQuestionCircle } from 'react-icons/ai'
import { calculateDiscountToBRL } from 'utlis/calculateDiscount'
import { currencyMask } from 'utlis/mask'
import InfoLabel from '../InfoLabel'
import { CardSubText, CardSummary, SummarySubText } from '../Summary/styles'
import { TDiscountAdd } from '../../utils/calculateAutomaticDiscount'

interface IInfoContract {
  studentData: IStudent
  contractPlans: IContractPlanDisplay[]
  createdFinancialMoviments: IFinancialMoviment[]
  subTotal: string
  total: string
  discount: string
  discountsAdd?: TDiscountAdd[]
  getPdfBoleto: (financialMovimentPaymentId: number, barCode: string) => void
  previewContract: () => void
  confirmContract: () => void
  handleClickOnOpenModalDescription: (menuFood: IMenuFood) => void
  handleClickOnOpenModalTableWithItems: (actualDishes: ISelectedDish[]) => void
  firstInstallmentValue: string
}

export const InfoContract = ({
  studentData,
  contractPlans,
  createdFinancialMoviments,
  discount,
  discountsAdd,
  subTotal,
  total,
  getPdfBoleto,
  previewContract,
  confirmContract,
  handleClickOnOpenModalDescription,
  handleClickOnOpenModalTableWithItems,
  firstInstallmentValue
}: IInfoContract) => {
  const [contractAccepted, setContractAccepted] = useState(false)
  let studentRestrictions = ''
  studentData.student_food_restrictions.forEach(
    ({ description }) => (studentRestrictions += description)
  )

  const discountsAddMap: Record<TDiscountAdd, string> = {
    hasBrother: 'Possui irmão/irmã com contrato ativo: 10%',
    moreThan4Plans:
      'Aluno do integral com mais de 4 planos com frequência de pelo menos 3 dias por semana: 10%',
    moreThan3Plans:
      'Aluno do integral com mais de 3 planos com frequência de pelo menos 3 dias por semana: 8%'
  }

  return (
    <div>
      <div className="mb-5">
        <h3 className="col-form-label fw-bold fs-5">Informações do cliente</h3>
        <div className="row">
          <InfoLabel
            title="Nome"
            description={studentData.client.name}
            colunm={3}
          />
          <InfoLabel
            title="CPF"
            description={studentData.client.cpf}
            colunm={3}
          />
          <InfoLabel
            title="E-mail"
            description={studentData.client.email}
            colunm={3}
          />
          <InfoLabel
            title="Telefone"
            description={studentData.client.phone}
            colunm={3}
          />
        </div>
      </div>
      <div className="separator my-5" />
      <div className="mb-5">
        <h3 className="col-form-label fw-bold fs-5">
          Informações do estudante
        </h3>
        <div className="row">
          <InfoLabel title="Nome" description={studentData.name} colunm={3} />
          <InfoLabel
            title="Turno"
            description={studentData.school_period}
            colunm={3}
          />
          <InfoLabel
            title="Ano/turma"
            description={studentData?.serie_class?.name}
            colunm={3}
          />
          <InfoLabel
            title="Restrições alimentares"
            description={studentRestrictions}
            colunm={12}
          />
        </div>
      </div>
      <div className="separator my-5" />
      <div>
        <h3 className="col-form-label fw-bold form-label fw-bold fs-5">
          Planos contratados
        </h3>
        <div className="row mb-5 gap-4">
          {contractPlans.map(contract => {
            return (
              <CardSummary key={contract.plan_id} className="col-md-3">
                <div className="d-flex justify-content-between gap-4">
                  <h3 style={{ color: '#3F4254' }}>
                    {contract.menu_food_type_name}
                  </h3>
                  <CardSubText>{contract.periodicity_payament}</CardSubText>
                </div>

                <p className="d-flex justify-content-between mb-2">
                  <CardSubText
                    className="fs-7 text-primary"
                    onClick={() =>
                      handleClickOnOpenModalDescription(contract.menu_food)
                    }
                    style={{ cursor: 'pointer' }}
                  >
                    Detalhes do cardápio
                  </CardSubText>
                  {contract.items_selected && (
                    <CardSubText
                      className="fs-7 text-primary"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        const selectedDishes = JSON.parse(
                          contract.items_selected
                        )
                        handleClickOnOpenModalTableWithItems(selectedDishes)
                      }}
                    >
                      Itens selecionados
                    </CardSubText>
                  )}
                </p>
                <p className="d-flex justify-content-between mb-2">
                  <SummarySubText>Valor do plano</SummarySubText>{' '}
                  <SummarySubText>
                    {currencyMask(contract.plan_value)}
                  </SummarySubText>
                </p>
                <SummarySubText>
                  Frequência:
                  {contract.frequency_days_of_week
                    ? JSON.parse(
                        contract.frequency_days_of_week
                      ).frequency_days_of_week.map((a: any) => (
                        <span key={a} style={{ padding: '5px' }}>
                          {a}
                        </span>
                      ))
                    : ''}
                </SummarySubText>
                <p className="d-flex justify-content-between">
                  <SummarySubText fontSize={13} color={'#464E5F'}>
                    Total
                  </SummarySubText>{' '}
                  <SummarySubText fontSize={13} color={'#464E5F'}>
                    {currencyMask(contract.value_with_discount)}
                  </SummarySubText>
                </p>
              </CardSummary>
            )
          })}
        </div>
      </div>
      <div className="separator my-5" />
      <div>
        <h3 className="col-form-label fw-bold form-label fw-bold fs-5">
          Informações do pagamento
        </h3>
        <div className="row">
          <InfoLabel
            title="Primeira mensalidade"
            description={firstInstallmentValue}
            colunm={3}
          />
        </div>
        <div className="row">
          <InfoLabel title="Subtotal" description={subTotal} colunm={3} />
          {discount !== 'R$ 0,00' && (
            <>
              <InfoLabel title="Desconto" description={discount} colunm={1} />
              {discountsAdd?.length && (
                <InfoLabel
                  title="Descontos aplicados"
                  description={discountsAdd
                    .map(d => discountsAddMap[d])
                    .join('. ')}
                  colunm={3}
                />
              )}
            </>
          )}
          <InfoLabel title="Total" description={total} colunm={3} />
        </div>
      </div>
      <div className="separator my-5" />

      <div className="d-flex gap-5 align-items-center">
        <h3 className="col-form-label fw-bold form-label fw-bold fs-5">
          Finalização da contratação
        </h3>
        <div className="h-100 d-flex align-items-center w-20">
          <Tooltip
            title="Após a confirmação, o sistema gerará o boleto do primeiro pagamento"
            widthContainer="auto"
            width={500}
          >
            <AiOutlineQuestionCircle
              fontSize={18}
              style={{ position: 'initial' }}
            />
          </Tooltip>
        </div>
      </div>
      <div>
        <button
          className="btn btn-secondary btn-sm"
          type="button"
          onClick={() => previewContract()}
        >
          Visualizar contrato
        </button>
      </div>
      <div className="d-flex">
        <input
          type="checkbox"
          name="confirm_payment"
          id="confirm_payment"
          checked={contractAccepted}
          onChange={() => setContractAccepted(prev => !prev)}
        />
        <label
          className="ps-4 py-4"
          htmlFor="confirm_payment"
        >{`Eu, ${studentData.client.name} concordo com os termos do contrato.`}</label>
      </div>
      <div>
        <button
          type="button"
          className="btn btn-primary end mb-4"
          onClick={() => confirmContract()}
          disabled={!contractAccepted}
        >
          Confirmar contratação
        </button>
      </div>
      {createdFinancialMoviments && createdFinancialMoviments.length > 0 && (
        <div>
          <h3 className="col-form-label fw-bold form-label fw-bold fs-5">
            Parcela do primeiro pagamento (Boleto)
          </h3>

          <div>
            <div className="table-responsive">
              <table
                id="kt_datatable"
                className="table table-striped table-row-bordered gs-3 border table-hover dataTable"
              >
                <thead className="border-bottom border-end">
                  <tr>
                    <th>Cód</th>
                    <th>Data de vencimento</th>
                    <th>Valor</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {createdFinancialMoviments?.map(
                    (financial_moviment, index) => {
                      if (index !== 0) return <></>
                      return (
                        <MenuTableRow key={financial_moviment.id}>
                          <td>{financial_moviment.id}</td>
                          <td>{financial_moviment.due_date.slice(0, 10)}</td>
                          <td>{currencyMask(financial_moviment.value)}</td>
                          <td>
                            <LinkContainer className="gap-2">
                              <div>
                                {financial_moviment.financialMovimentsPayments && (
                                  <span
                                    className="fa fa-print"
                                    style={{
                                      border: 'none',
                                      color: '#009EF7',
                                      cursor: 'pointer'
                                    }}
                                    onClick={() =>
                                      getPdfBoleto(
                                        financial_moviment
                                          .financialMovimentsPayments[0].id,
                                        financial_moviment
                                          .financialMovimentsPayments[0]
                                          .bar_code
                                      )
                                    }
                                  />
                                )}
                              </div>
                            </LinkContainer>
                          </td>
                        </MenuTableRow>
                      )
                    }
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
